
import { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';

import { useQuery } from "@tanstack/react-query";

import { IconButton, Button } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faFileExcel} from '@fortawesome/free-solid-svg-icons';



import { SearchOutlined } from '@ant-design/icons';
import { FilterFilled } from '@ant-design/icons';



import { Dropdown, Menu, Form, Space, DatePicker, Row, Col } from 'antd';


// import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

import authAxios from "../components/authAxios";

import moment from 'moment';



// import Layout from "../components/Layout";
import DashboardHeader from "../components/DashboardHeader";
import './EndMonthReport.css'

import { width } from "@fortawesome/free-brands-svg-icons/fa42Group";

import Loading from "../components/Loading";


const ExpenseSchedule = () => {
    const location = useLocation();
    const [reportMonth, setReportMonth] = useState(moment().format('MM'))
    const [reportYear, setReportYear] = useState(moment().format('YYYY'))

    const { data: expenseSchedule, isLoading } = useQuery({
        queryKey: ['expense-schedule', reportMonth, reportYear],
        queryFn: async () => {
            const response = await authAxios.get(`/accounting/expense-schedule/?year=${reportYear}`);
            return response.data
        },
    });


    if (isLoading) return <Loading loading={true} />;
    const { headers = [], rows = [], totals } = expenseSchedule;

    const downloadXLS = () => {

        const worksheetData = expenseSchedule.report_data.map(data => ({
            'No': data.id,
            'Property': data.name,
            'Rent Payable': parseFloat(data.rent_payable),
            'Royalty BF': parseFloat(data.royalty_bf),
            'Collectable B/F': parseFloat(data.collectable_bf),
            'Rent Paid': parseFloat(data.rent_paid),
            'Royalty Due': parseFloat(data.royalty_due),
            'Royalty Disbursed': parseFloat(data.owner_payments),
            'Commission': parseFloat(data.commission),
            'Royalty C/F': parseFloat(data.royalty_cf),
            'Collectable C/F': parseFloat(data.collectable_cf),
            'Total Income': parseFloat(data.total_income),
        })); 

        // Add the totals row at the end
        const totalsRow = {
            'No': '', // Label for the totals row
            'Property': 'TOTALS', // Leave empty for non-numeric columns
            'Rent Payable': parseFloat(expenseSchedule.totals.rent_payable),
            'Royalty BF': parseFloat(expenseSchedule.totals.royalty_bf),
            'Collectable B/F': parseFloat(expenseSchedule.totals.collectable_bf),
            'Rent Paid': parseFloat(expenseSchedule.totals.rent_paid),
            'Royalty Due': parseFloat(expenseSchedule.totals.royalty_due),
            'Royalty Disbursed': parseFloat(expenseSchedule.totals.owner_payments),
            'Commission': parseFloat(expenseSchedule.totals.commission),
            'Royalty C/F': parseFloat(expenseSchedule.totals.royalty_cf),
            'Collectable C/F': parseFloat(expenseSchedule.totals.collectable_cf),
            'Total Income': parseFloat(expenseSchedule.totals.total_income),
        };

        // Push the totals row to the worksheet data
        worksheetData.push(totalsRow);

        // Convert data to worksheet
        const ws = XLSX.utils.json_to_sheet(worksheetData);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'End Month Report');

        XLSX.writeFile(wb, `End_Month_Report_${reportMonth}_${reportYear}.xlsx`);
    };

    const onChange = (date, dateString) => {
        // console.log(date);
        // setReportMonth(date.month()+1)
        setReportYear(date.year())
      };

    const menu = (
        <Menu>
            <form className="filter-form">
                <Space direction="vertical">
                    <DatePicker onChange={onChange} picker="year" placement="bottomRight" />
                </Space>
            </form>
        </Menu>
      );
    // const reportPreTitle="PERIOD "+reportMonth+"/"+reportYear
    const reportPreTitle="PERIOD "+reportYear



    // a helper function to check if a column has data
    const hasColumnData = (columnName) => {
        return expenseSchedule.report_data.some(row => row[columnName] !== 0 && row[columnName] !== null && row[columnName] !== undefined);
      };

    const formatNumber = (number) => {
        return number.toLocaleString('en-UK', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }


    return (
        <div className="dashboard-main end-month-report expense-schedule">
            <section className="dashboard-content">
                <div className="dashboard-content-header-nav">
                    <DashboardHeader dashboardTitle="Expense Schedule" dashboardPreTitle={reportPreTitle} />
                    <div className="dashboard-content-header-nav-icons">
                        <IconButton onClick={downloadXLS}>
                            <FontAwesomeIcon className="menu-icon" icon={faFileExcel} />
                        </IconButton>
                        <Dropdown overlay={menu} trigger={['click']} placement="bottomRight" arrow>
                      
                        <Button className="menu-button-filter" variant="outlined" startIcon={<TuneIcon />}>
                            Filter
                        </Button>

                    </Dropdown>
                    </div>
                
                </div>
                <div className="table-container">


                <table >
                        <thead>
                            <tr>
                                <th>NO</th>
                                {headers.map(data => (
                                    <th key={data}>{data.toUpperCase()}</th>
                                ))}
                            </tr>
                        </thead>
                          
                        <tbody >
                            {rows.map((data, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                {headers.map(hdr => (
                                    <td key={hdr}>{data[hdr].toLocaleString()}</td>
                                ))}
                            </tr>
                            ))}

                        </tbody>
                        {totals && (
                            <tfoot>
                                <tr>
                                    <td></td>
                                    {headers.map(hdr => (
                                        <td key={hdr}>
                                            {hdr === "account"
                                                ? "TOTALS"
                                                : totals[hdr].toLocaleString()
                                            }
                                        </td>
                                    ))}
                                </tr>
                            </tfoot>
                        )}


                </table>

                </div>



            </section>
        </div>
    );
};

export default ExpenseSchedule;


